<template>
  <div>
    <v-card class="py-3 px-3 mb-3">
      <div class="d-flex align-center justify-space-between mb-3">
        <h4 class="text-uppercase">
          {{ $vuetify.lang.t(`$vuetify.labels.${addressType === 1 ? 'shippingAddress' : 'billingAddress'}`) }}
        </h4>
      </div>

      <div class v-if="address.firstName">
        <div>{{ `${address.firstName} ${address.lastName}` }}</div>
        <div>{{ address.street }}</div>
        <div>{{ address.city ? `${address.city}, ` : '' }}{{ address.postCode ? address.postCode : '' }}</div>
        <div>{{ address.countryId }}</div>
      </div>
      <template v-if="address.isCompany">
        <div v-if="address.companyName">
          {{ $vuetify.lang.t('$vuetify.labels.companyName') }}: {{ address.companyName }}
        </div>
        <div v-if="address.companyIdentificationNumber">
          {{ $vuetify.lang.t('$vuetify.labels.companyIdNumber') }}:
          {{ address.companyIdentificationNumber }}
        </div>
        <div v-if="address.companyVatNumber">
          {{ $vuetify.lang.t('$vuetify.labels.companyVatNumber') }}:
          {{ address.companyVatNumber }}
        </div>
      </template>
      <div v-if="address.street" class="d-flex justify-end mt-3">
        <v-icon color="primary">$vuetify.icons.mapMarker</v-icon>
        <a v-bind:href="addressLocation" target="_blank" class="link ml-2">{{
          $vuetify.lang.t(`$vuetify.labels.showOnMap`)
        }}</a>
      </div>
    </v-card>
  </div>
</template>

<script>
import { OrderAddressesApiService } from '../../../common/services/order-addresses.api.service';

export default {
  props: {
    address: {
      type: Object,
      default: null,
    },
  },

  computed: {
    addressType() {
      if (!this.address) {
        return null;
      }

      return this.address.type;
    },

    addressLocation() {
      if (!this.address) {
        return '';
      }

      const street = this.address.street.replace('/', ' ');
      const city = this.address.city.replace('/', ' ');
      const postCode = this.address.postCode.replace('/', ' ');
      const countryId = this.address.countryId.replace('/', ' ');

      return `https://google.com/maps/place/${street} ${city}, ${postCode} ${countryId}`;
    },

    orderId() {
      return this.$route.params.id;
    },
  },

  methods: {
    saveAddress() {
      let formData = this.$refs.addressForm.save();

      if (!formData) {
        return;
      }

      let request;
      if (this.addressType === 1) {
        request = OrderAddressesApiService.patchShipping(this.orderId, formData);
      } else if (this.addressType === 2) {
        request = OrderAddressesApiService.patchBilling(this.orderId, formData);
      }

      request
        .then(() => {
          this._openCloseDrawer(false);
          this.$emit('saved');
        })
        .catch(response => {
          this.$alertError(response.getFirstValidationErrorMessage() || response.getMessage());
        });
    },

    _openCloseDrawer(event) {
      this.drawerIsOpen = event;
    },
  },
};
</script>

<style lang="scss" scoped></style>
